import { supabase } from '../supabaseClient';

const TABLE_NAME = 'unlimited_game_state';
const MAX_USED_WORD_IMAGES = 500;

const capArray = (arr, maxLen) => {
  if (!Array.isArray(arr)) return [];
  if (arr.length <= maxLen) return arr;
  return arr.slice(arr.length - maxLen);
};

const sanitizeGameState = (gameState) => {
  if (!gameState || typeof gameState !== 'object') return {};

  // Avoid persisting transient UI fields that change frequently (saves DB writes + payload).
  // Keep gameplay-relevant fields so the user can resume accurately.
  // eslint-disable-next-line no-unused-vars
  const { loading, isChecking, isTransitioning, ...rest } = gameState;
  return rest;
};

export const getSavedGameDb = async (userId) => {
  if (!userId) return null;

  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('state')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error reading saved game from DB:', error);
      return null;
    }

    return data?.state || null;
  } catch (error) {
    console.error('Unexpected error reading saved game from DB:', error);
    return null;
  }
};

export const saveGameDb = async (userId, gameState, usedLetters, usedWordImages) => {
  if (!userId) return false;

  const stateToSave = {
    ...sanitizeGameState(gameState),
    usedLetters: Array.from(usedLetters),
    usedWordImages: capArray(Array.from(usedWordImages), MAX_USED_WORD_IMAGES),
  };

  try {
    const { error } = await supabase
      .from(TABLE_NAME)
      .upsert(
        {
          user_id: userId,
          state: stateToSave,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.error('Error saving game to DB:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Unexpected error saving game to DB:', error);
    return false;
  }
};

export const clearSavedGameDb = async (userId) => {
  if (!userId) return false;

  try {
    const { error } = await supabase.from(TABLE_NAME).delete().eq('user_id', userId);
    if (error) {
      console.error('Error clearing saved game in DB:', error);
      return false;
    }
    return true;
  } catch (error) {
    console.error('Unexpected error clearing saved game in DB:', error);
    return false;
  }
};
